import React, { useState } from "react";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { api } from "../../../app/Api/ApiSlice";
import { usePaystackPayment } from "react-paystack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const Checkout = () => {
    const [paymentMethod, setPaymentMethod] = useState("mpesa");
    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);
    const [period, setPeriod] = useState(1)
    const [loadingPayPal, setLoadingPaypal] = useState(false)
    // const [loadMpesa,setLoadMpesa] = useState(false)
    // const [amount,setAmount] = useState()

    const { name } = useParams()
    const location = useLocation()
    const { details } = location.state

    // console.log(details)

    const navigate = useNavigate()

    const subscription = {
        name: details.plan,
        price: details.price,
        currency: "KES",
    };

    const userEmail = details.storeContacts.contacts?.email
    const totalAmount = details.price * period
    const reference = `ONNIZE_${Date.now()}`;

    /* =======================
       M-PESA
    ======================== */
    const handleMpesaPayment = async () => {
        setLoading(true);
        try {
            const response = await api.post("/payments/mpesa", {
                phone,
                amount: totalAmount,
                plan: details.plan,
                storeId: details.storeContacts.contacts._id
            });
            setLoading(false)
            if (response.data.success === true) {
            }
        } catch (err) {
            // console.log(err)
            alert("Failed to initiate M-Pesa payment");
        } finally {
            setLoading(false);
        }
    };

    /* =======================
       PAYSTACK
    ======================== */
    // console.log("env:",process.env.REACT_APP_PAYSTACK_PUBLIC_KEY)
    const paystackConfig = {
        reference,
        email: userEmail,
        amount: totalAmount * 100,
        publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
        currency: "KES",
    };

    const initializePaystack = usePaystackPayment(paystackConfig);

    const verifyPaystackPayment = async (ref) => {
        try {
            setLoading(true);
            const res = await api.get(`/paystack/verify/${ref}`);

            if (res.data.success) {
                toast.success("payment succesful")
                navigate(`/b/${name}/admin`)
            } else {
                alert("Payment verification failed");
            }
        } catch (err) {
            alert("Verification error");
        } finally {
            setLoading(false);
        }
    };

    const handlePaystackPayment = () => {
        initializePaystack(
            (ref) => {
                verifyPaystackPayment(ref.reference);
            },
            () => {
                console.log("Paystack checkout closed");
            }
        );
    };

    return (
        <div className="checkout">
            <h2>Complete Subscription Payment</h2>

            {/* SUMMARY */}
            <div className="summary">
                <p><strong>{subscription.name}</strong></p>
                <p>
                    Amount: {subscription.currency} {details.price}/month
                </p>
                <div>
                    <label className="form-label">
                        Period:
                        <select value={period} onChange={(e) => setPeriod(Number(e.target.value))}>
                            {[...Array(12)].map((_, i) => (
                                <option key={i} value={i + 1}>
                                    {i + 1} Month{i > 0 ? "s" : ""}
                                </option>
                            ))}
                        </select>
                    </label>
                </div>
                <p><strong>Total:{totalAmount}</strong></p>
            </div>

            {/* PAYMENT METHOD SELECTOR */}
            <div className="methods">
                <button
                    className={paymentMethod === "mpesa" ? "active" : ""}
                    onClick={() => setPaymentMethod("mpesa")}
                >
                    M-Pesa
                </button>

                <button
                    className={paymentMethod === "paystack" ? "active" : ""}
                    onClick={() => setPaymentMethod("paystack")}
                >
                    Paystack
                </button>

                <button
                    className={paymentMethod === "paypal" ? "active" : ""}
                    onClick={() => setPaymentMethod("paypal")}
                >
                    PayPal
                </button>
            </div>

            {/* =======================
                M-PESA UI
            ======================== */}
            {paymentMethod === "mpesa" && (
                <div className="payment-section">
                    <label>M-Pesa Phone Number</label>
                    <input
                        type="tel"
                        placeholder="07XXXXXXXX"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                    />

                    <button onClick={handleMpesaPayment} disabled={loading} className="payment-btn">
                        {loading ? "Processing..." : "Pay with M-Pesa"}
                    </button>
                </div>
            )}

            {/* =======================
                PAYSTACK UI
            ======================== */}
            {paymentMethod === "paystack" && (
                <div className="payment-section">
                    <button onClick={handlePaystackPayment} disabled={loading} className="payment-btn">
                        {loading ? "Redirecting..." : "Pay with Paystack"}
                    </button>
                </div>
            )}
            {loadingPayPal && <p>Please wait...</p>}

            {/* =======================
                PAYPAL UI
            ======================== */}
            {paymentMethod === "paypal" && (
                <div className="payment-section">
                    <PayPalScriptProvider
                        options={{
                            "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
                            currency: "USD",
                        }}
                    >
                        <PayPalButtons
                            createOrder={async () => {
                                setLoadingPaypal(true)
                                const res = await api.post(
                                    "/payments/paypal/create-order",
                                    { amount: totalAmount }
                                );
                                setLoadingPaypal(false)
                                return res.data.id;
                            }}
                            onApprove={async (data) => {
                                await api.post(
                                    "/payments/paypal/capture-order",
                                    { orderID: data.orderID }
                                );
                                alert("PayPal payment successful");
                            }}
                            onError={() => {
                                alert("PayPal payment failed");
                            }}
                        />
                    </PayPalScriptProvider>
                </div>
            )}
        </div>
    );
};

export default Checkout;
